<template>
  <div id="subject-comment-detail">
    <div style="padding: 15px">
      <div style="margin: 20px 0px; text-align: center">
        <span style="font-size: 22px">--热门评论--</span>
      </div>
      <div class="commentDiv">
        <input
          v-model="comment"
          class="send-box"
          maxlength="10"
          @keydown.13="addComment"
          placeholder="我来说两句"
        />
        <div>
          <button class="send-btn" @click="addComment">评论</button>
        </div>
      </div>
      <div style="margin-top: 30px">
        <div
          style="
            margin-bottom: 1rem;
            padding-bottom: 1rem;
            border-bottom: 1px solid #ccc;
          "
          v-for="(item, key) in commentsList"
          :key="key"
        >
          <div style="display: flex">
            <div class="head">
              <img :src="item.avatar" />
            </div>
            <div
              style="
                display: flex;
                flex-direction: column;
                justify-content: center;
              "
            >
              <div style="color: #949494; font-size: 15px; margin-top: -2px">
                {{ item.username }}
              </div>
              <div style="color: #949494; font-size: 15px; margin-top: 3px">
                {{ item.createTime | filterData }}
              </div>
            </div>
          </div>
          <div style="margin-top: 10px">
            <span>{{ item.content }}</span>
          </div>
        </div>
        <div v-if="commentsList.length === 0">目前还没有评论哦</div>
      </div>
    </div>
  </div>
</template>

<script>
import request, {
  getResourceNewsDetail,
  getCommentsByTypeById,
  getResourceNewsRecently,
  createComments,
} from "@/utils/request";
import moment from "moment";
import "moment/locale/zh-cn";

export default {
  components: {},
  filters: {
    filterData(time) {
      return moment(time).fromNow();
    },
  },
  data() {
    return {
      comment: "",
      commentsList: [],
      commentsTotal: 0,
      recomments: [],
      emojiPanelVisible: false,
    };
  },
  props: {
    id: {
      type: String,
    },
  },
  mounted() {
    this.getCommentList();
  },
  methods: {
    addComment() {
      if (this.comment.length > 0) {
        createComments({
          content: this.comment,
          objectId: this.$props.id,
          offset: 0,
          toUserId: 0,
          type: "TO_SUBJECT",
        }).then(() => {
          this.$message({
            message: "评论成功",
            type: "success",
          });
          this.comment = "";
          this.getCommentList();
        });
      }
    },
    getCommentList() {
      getCommentsByTypeById({
        id: this.$props.id,
        type: "TO_SUBJECT",
      }).then((result) => {
        if (result.data) {
          this.commentsTotal = result.data.length;
          this.commentsList = result.data.reverse();
        } else {
          this.commentsTotal = 0;
          this.commentsList = [];
        }
      });
    },
    handleLike() {
      // postLikes({
      //   resourceId: 0,
      //   resourceType: "NEWS",
      // }).then(() => {
      //   this.$message({
      //     message: "点赞成功",
      //     type: "success",
      //   });
      // });
    },
    listRecommends() {
      getResourceNewsRecently({
        size: 11,
      }).then((res) => {
        this.recomments = res.data[0].news;
      });
    },
    insertEmoji(i) {
      this.comment = this.comment + "emoji:" + i + " ";
      this.emojiPanelVisible = false;
    },
  },
};
</script>

<style lang="less">
#subject-comment-detail {
  .commentDiv {
    padding-bottom: 10px;
    display: flex;
    align-items: center;
    .send-box {
      background-color: #fff;
      border: 1px solid rgba(153, 153, 153, 1);
      margin-right: 5%;
      height: 50px;
      width: calc(100% - 80px);
      padding: 0 1rem;
      outline: none;
      border-radius: 0.4rem;
    }
    div {
      .send-btn {
        border: none;
        width: 80px;
        margin-right: 10px;
        line-height: 30px;
        border-radius: 30px;
        outline: none;
        background-color: rgba(2, 167, 240, 1);
        color: white;
      }
    }
  }
}
.head {
  cursor: pointer;
  width: 5rem;
  height: 4rem;

  img {
    height: 4rem;
    width: 4rem;
    border-radius: 50%;
  }
}
@media screen and (max-width: 560px) {
  img {
    max-width: 100% !important;
  }
  video {
    max-width: 100% !important;
  }
  iframe {
    height: 300px !important;
  }
  .content {
    border: none;
  }
  .content p {
    width: 100%;
  }
}
</style>

